<div class="container new-announcement">
    <header class="m-b-md">
        <h2 class="strong">New Announcement</h2>
        <a *ngIf="!isSpinnerShow" routerLink="/announcements" class="close">×</a>
    </header>

    <main>
        <form #form="ngForm"
              autocomplete="off"
              (ngSubmit)="onSubmit(form)"
              [ngClass]="{'ng-submitted': form.submitted, 'sk-loading': isSpinnerShow}">

            <!-- Subject -->
            <div class="form-group row">
                <div class="col-xs-2">
                    <label class="title">Subject: </label>
                </div>
                <div class="col-xs-10">
                    <input class="form-control" name="subject" [(ngModel)]="notice.title" required>
                </div>
            </div>

            <!-- Corporation number -->
            <div *ngIf="corporationNumberOptions.length > 1" class="form-group row">
                <div class="col-xs-2">
                    <label class="title">Corporation: </label>
                </div>
                <div class="col-xs-10">
                    <search-select [(ngModel)]="notice.corporationNumberId" (ngModelChange)="corporationChange($event)"
                                   class="form-control" name="corporationNumberId" required
                                   [data]="corporationNumberOptions"></search-select>
                </div>
            </div>

            <!-- Active date -->
            <div class="form-group row">
                <div class="col-xs-2">
                    <label class="title">Active Date: </label>
                </div>
                <div class="col-xs-4">
                    <date-select-field [(ngModel)]="notice.periodBegin" [minDate]="today"
                                       (ngModelChange)="periodBeginChange()" name="periodBegin"
                                       required></date-select-field>
                </div>
                <div class="col-xs-6 row">
                    <div class="col-sm-3">
                        <label class="img-checkbox">
                            <input [(ngModel)]="isEndDateEnabled"
                                   (ngModelChange)="notice.periodEnd = null; form.controls.isEndDateEnabled.markAsTouched();"
                                   id="isEndDateEnabled"
                                   type="checkbox"
                                   name="isEndDateEnabled">
                            <label for="isEndDateEnabled">
                                <svg-checked></svg-checked>
                                <span>Expire</span>
                            </label>
                        </label>
                    </div>
                    <date-select-field [(ngModel)]="notice.periodEnd"
                                       [minDate]="notice.periodBegin"
                                       (ngModelChange)="periodEndChange()"
                                       [disabled]="!isEndDateEnabled"
                                       name="periodEnd"
                                       class="col-sm-9"
                                       required>
                    </date-select-field>
                </div>
            </div>

            <!-- Type -->
            <div class="form-group row reply-to-field">
                <div class="col-xs-2">
                    <label class="title">Type:</label>
                </div>
                <div class="col-sm-4">
                    <select class="form-control" name="isFile" [(ngModel)]="isFile">
                        <option [ngValue]="false">Editor</option>
                        <option [ngValue]="true">File</option>
                    </select>
                </div>
            </div>

            <text-editor-field *ngIf="!isFile" name="noticeText" [(ngModel)]="notice.text"
                               required=""></text-editor-field>

            <div *ngIf="isFile">
                <file-upload *ngIf="!notice.document"
                             hint="Click here to upload announcement"
                             [supportedFileTypes]="supportedFileTypes"
                             (onFileUploaded)="onFileUploaded($event)">
                </file-upload>
              <div *ngIf="notice.document" class="view-container">
                <span class="close" (click)="notice.document = null">×</span>
                <announcement-view [fileDocument]="notice.document"
                                   [maxHeight]="announcementViewHeight">
                </announcement-view>
              </div>
            </div>

            <spinner [spinnerShow]="false"></spinner>

            <div class="row btn-box">
                <div class="col-sm-9">
                    <label *ngIf="notice.id" class="img-checkbox">
                        <input id="resendToSubscribers" type="checkbox" name="resendToSubscribers"
                               [(ngModel)]="notice.resendToSubscribers">
                        <label for="resendToSubscribers">
                            <svg-checked></svg-checked>
                            <span>Send Announcement to Subscribers</span>
                        </label>
                    </label>
                </div>
                <div class="col-sm-3">
                    <button type="submit" class="btn btn-primary submit-btn"
                            [disabled]="disabledSubmit">{{notice.id ? 'Update' : 'Publish'}}</button>
                </div>
            </div>
        </form>

        <spinner [spinnerShow]="isSpinnerShow"></spinner>
    </main>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/announcements/announcements-add/announcements-add.component.html